var map = {
	"./authenticated/authenticated.module": [
		"./src/app/authenticated/authenticated.module.ts",
		"default~authenticated-authenticated-module~curriculum-year-dashboard-curriculum-year-dashboard-modul~2096370b",
		"authenticated-authenticated-module"
	],
	"./badges/badges.module": [
		"./src/app/authenticated/badges/badges.module.ts",
		"badges-badges-module"
	],
	"./course-lists/course-lists.module": [
		"./src/app/authenticated/course-lists/course-lists.module.ts",
		"course-lists-course-lists-module"
	],
	"./courses/courses.module": [
		"./src/app/authenticated/courses/courses.module.ts",
		"default~courses-courses-module~programs-programs-module",
		"courses-courses-module"
	],
	"./curriculum-year-dashboard/curriculum-year-dashboard.module": [
		"./src/app/authenticated/curriculum-year-dashboard/curriculum-year-dashboard.module.ts",
		"default~authenticated-authenticated-module~curriculum-year-dashboard-curriculum-year-dashboard-modul~2096370b"
	],
	"./general-education-patterns/general-education-patterns.module": [
		"./src/app/authenticated/general-education-patterns/general-education-patterns.module.ts",
		"general-education-patterns-general-education-patterns-module"
	],
	"./high-schools/high-schools.module": [
		"./src/app/authenticated/high-schools/high-schools.module.ts",
		"high-schools-high-schools-module"
	],
	"./programs/programs.module": [
		"./src/app/authenticated/programs/programs.module.ts",
		"default~courses-courses-module~programs-programs-module",
		"programs-programs-module"
	],
	"./publish/publish.module": [
		"./src/app/authenticated/publish/publish.module.ts",
		"publish-publish-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;